class MiniCartRecommendationCard extends HTMLLIElement {
  constructor () {
    super()
    this.elements = {
      form: null,
      variantInput: null,
      select: null,
      defaultState: null,
      loadingState: null,
      submitButton: null,
      cartItems: document.querySelector('cart-items')
    }

    this.state = {
      addingToCart: false
    }
  }

  connectedCallback () {
    this.elements.form = this.querySelector('.mini-cart-recommendation-card_form')
    this.elements.variantInput = this.querySelector('[data-mini-cart-recommendation-el="variantInput"]')
    this.elements.select = this.querySelector('[data-mini-cart-recommendation-el="select"]')
    this.elements.defaultState = this.querySelector('[data-mini-cart-recommendation-el="default-state"]')
    this.elements.loadingState = this.querySelector('[data-mini-cart-recommendation-el="loading-state"]')
    this.elements.submitButton = this.querySelector('.mini-cart-recommendation-card_submit')

    this.attachEventListeners()
  }

  attachEventListeners () {
    if (this.elements.select) {
      this.elements.select.addEventListener('change', (e) => this.onSelectChange(e))
    }

    if (this.elements.form) {
      this.elements.form.addEventListener('submit', (e) => this.onFormSubmit(e))
    }
  }

  onSelectChange (e) {
    const selectedVariantId = e.target.value
    if (this.elements.variantInput) {
      this.elements.variantInput.value = selectedVariantId
    }
  }

  async onFormSubmit (e) {
    e.preventDefault()

    if (this.state.addingToCart) return

    const variantId = this.elements.variantInput?.value
    if (!variantId) return

    this.setLoadingState(true)

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          sections: this.elements.cartItems?.getSectionsToRender().map((section) => section.id) || [],
          sections_url: window.location.pathname,
          items: [
            {
              id: Number(variantId),
              quantity: 1
            }
          ]
        })
      })

      if (response.ok) {
        const json = await response.json()

        this.elements.cartItems?.renderContents(json)

        const addToCartEvent = new CustomEvent('GA_ADD_TO_CART', {
          detail: {
            formName: 'miniCartRecommendation',
            item: json.items[0]
          }
        })
        window.dispatchEvent(addToCartEvent)
      } else {
        console.error('Failed to add product to cart')
      }
    } catch (error) {
      console.error('Error adding product to cart:', error)
    } finally {
      this.setLoadingState(false)
    }
  }

  setLoadingState (isLoading) {
    this.state.addingToCart = isLoading

    if (this.elements.submitButton) {
      this.elements.submitButton.disabled = isLoading
    }

    if (this.elements.defaultState) {
      this.elements.defaultState.classList.toggle('hidden', isLoading)
    }

    if (this.elements.loadingState) {
      this.elements.loadingState.classList.toggle('hidden', !isLoading)
    }
  }
}

customElements.define('mini-cart-recommendation-card', MiniCartRecommendationCard, { extends: 'li' })
